import "../components/Home/Home.scss";
import ProductList from "../components/Home/ProductList";
import ContactUs from "../components/Home/ContactUs";
import AboutUs from "../components/Home/AboutUs";
import { useState, useEffect } from "react";
import FirstSlider from "../components/Home/FirstSlider";
import sendRequest from "../hooks/useAxios";
import i1 from "../assets/images/test/1.png";
import i2 from "../assets/images/test/2.png";
import i3 from "../assets/images/test/3.jpg";
import { useLocation } from "react-router-dom";
import ChatWidget from "../components/chat/ChatWidget";
import "../components/chat/chat.scss";
import styles from "@chatscope/chat-ui-kit-styles/dist/default/styles.min.css";

export default function Home() {
  const [productList, setProductList] = useState([]);
  const clickOnProduct = (pid, subid, rout) => {
    sendRequest("?action=add_visit", {
      product_id: pid,
      sub_product_id: subid,
      url: rout,
    });
  };
  const rout = useLocation().search;
  useEffect(() => {
    clickOnProduct("0", "0", rout);
    sendRequest("?action=get_product_with_sub_product").then((data) => {
      if (data.data.state == 1) {
        setProductList(data.data.result);
      }
    });
  }, []);

  return (
    <div className="mx-auto home-style" style={{ width: "90%" }}>
      <FirstSlider />
      <ProductList
        productListData={productList}
        clickOnProduct={clickOnProduct}
        rout={rout}
      />
      <AboutUs />
      <ContactUs />
      <div className="chat-style">
        {" "}
        <ChatWidget />
      </div>
    </div>
  );
}
